<template>
  <div class="approver-info">
    <div class="page-header">
      <h2>审批员信息</h2>
      <div class="header-actions">
        <el-input v-model="search" placeholder="搜索姓名/用户名" style="width:200px;margin-right:10px" clearable @clear="load" @keyup.enter="load">
          <template #prefix><el-icon><search /></el-icon></template>
        </el-input>
        <el-button type="primary" @click="openAdd"><el-icon><plus /></el-icon>新增审批员</el-button>
      </div>
    </div>

    <!-- PC端表格 -->
    <el-table v-if="!isMobile" :data="tableData" border stripe style="width:100%" v-loading="loading">
      <el-table-column prop="username" label="用户名" width="140" />
      <el-table-column prop="name" label="姓名" width="120" />
      <el-table-column prop="department" label="部门" width="140">
        <template #default="{row}">
          <el-tag :type="deptTagType(row.department)">{{ row.department }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="created_at" label="创建时间" width="180">
        <template #default="{row}">{{ formatDate(row.created_at) }}</template>
      </el-table-column>
      <el-table-column label="操作" width="180" fixed="right">
        <template #default="{row}">
          <el-button size="small" @click="openEdit(row)">编辑</el-button>
          <el-popconfirm title="确定删除该审批员?" @confirm="handleDelete(row)">
            <template #reference>
              <el-button size="small" type="danger">删除</el-button>
            </template>
          </el-popconfirm>
        </template>
      </el-table-column>
    </el-table>

    <!-- 手机端卡片 -->
    <div v-else class="mobile-list">
      <div v-for="item in tableData" :key="item.username" class="approver-card">
        <div class="card-header">
          <span class="card-name">{{ item.name }}</span>
          <el-tag :type="deptTagType(item.department)" size="small">{{ item.department }}</el-tag>
        </div>
        <div class="card-info">
          <span>用户名：{{ item.username }}</span>
          <span>创建时间：{{ formatDate(item.created_at) }}</span>
        </div>
        <div class="card-actions">
          <el-button size="small" @click="openEdit(item)">编辑</el-button>
          <el-popconfirm title="确定删除该审批员?" @confirm="handleDelete(item)">
            <template #reference>
              <el-button size="small" type="danger">删除</el-button>
            </template>
          </el-popconfirm>
        </div>
      </div>
      <el-empty v-if="!loading && tableData.length===0" description="暂无数据" />
    </div>

    <el-pagination
      v-model:current-page="pageNum"
      v-model:page-size="pageSize"
      :total="total"
      :page-sizes="[5,10,20]"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="load"
      @current-change="load"
      style="margin-top:15px"
    />

    <!-- 新增/编辑弹窗 -->
    <el-dialog :title="form.id?'编辑审批员':'新增审批员'" v-model="dialogVisible" width="450px" :close-on-click-modal="false" class="approver-dialog">
      <el-form ref="formRef" :model="form" :rules="rules" label-width="80px">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="form.username" :disabled="!!form.id" placeholder="请输入用户名" />
        </el-form-item>
        <el-form-item label="姓名" prop="name">
          <el-input v-model="form.name" placeholder="请输入姓名" />
        </el-form-item>
        <el-form-item label="部门" prop="department">
          <el-select v-model="form.department" placeholder="请选择部门" style="width:100%">
            <el-option label="总务科" value="总务科" />
            <el-option label="学工科" value="学工科" />
            <el-option label="校领导" value="校领导" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="!form.id" label="密码" prop="password">
          <el-input v-model="form.password" type="password" show-password placeholder="请输入密码" />
        </el-form-item>
        <el-form-item v-if="form.id" label="重置密码">
          <el-input v-model="form.password" type="password" show-password placeholder="留空则不修改" />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button type="primary" @click="handleSave">确定</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script src="@/assets/js/ApproverInfo.js"></script>

<style scoped>
.approver-info { padding: 20px; }
.page-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 15px; flex-wrap: wrap; gap: 10px; }
.page-header h2 { margin: 0; font-size: 18px; }
.header-actions { display: flex; align-items: center; flex-wrap: wrap; gap: 5px; }

/* 手机端卡片 */
.mobile-list { display: flex; flex-direction: column; gap: 10px; }
.approver-card { background: #fff; border-radius: 8px; padding: 14px; box-shadow: 0 1px 4px rgba(0,0,0,0.08); }
.card-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 8px; }
.card-name { font-size: 16px; font-weight: 600; }
.card-info { display: flex; flex-direction: column; gap: 4px; font-size: 13px; color: #666; margin-bottom: 10px; }
.card-actions { display: flex; gap: 8px; }

@media (max-width: 768px) {
  .approver-info { padding: 10px; }
  .page-header h2 { font-size: 16px; }
  .header-actions { width: 100%; }
  .header-actions .el-input { width: 100% !important; }
}
</style>
